<template>
  <component :is="template" :spec="field.spec" :errors="field.errors" :saving="saving">
    <template #editable>
      <div class="flex flex-row">
        <input class="text-input bg-middle" type="number" v-model.number="proxy" :placeholder="field.spec.placeholder">
        <button v-if="proxy" @click="proxy = null" class="input-icon-button bg-middle">
          <font-awesome-icon icon="times" />
        </button>
      </div>
    </template>
    <template #readonly>
      <span class="ml2">{{ field.value }}</span>
    </template>
  </component>
</template>

<script>
export default {
  props: ['field', 'template', 'saving'],
  watch: {
    field (f) {
      if (f.spec.causer) return
      this.model = f.value
    }
  },
  computed: {
    proxy: {
      get () { return this.model },
      set (v) {
        this.model = v
        this.$emit('input', { value: v, debounced: !!v })
      }
    }
  },
  data () {
    return {
      model: this.field.value
    }
  }
}
</script>
